const info = [
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'acrechain',
            client_id: '07-tendermint-13',
            connection_id: 'connection-14'
        },
        chain_2: {
            chain_name: 'terra',
            client_id: '07-tendermint-172',
            connection_id: 'connection-99'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-12',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-69',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'crescent',
            client_id: '07-tendermint-0',
            connection_id: 'connection-0'
        },
        chain_2: {
            chain_name: 'terra',
            client_id: '07-tendermint-101',
            connection_id: 'connection-70'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-0',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-49',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true,
                    dex: 'crescent'
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'juno',
            client_id: '07-tendermint-63',
            connection_id: 'connection-43'
        },
        chain_2: {
            chain_name: 'terra',
            client_id: '07-tendermint-32',
            connection_id: 'connection-34'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-27',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-20',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'osmosis',
            client_id: '07-tendermint-1215',
            connection_id: 'connection-1549'
        },
        chain_2: {
            chain_name: 'terra',
            client_id: '07-tendermint-12',
            connection_id: 'connection-11'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-72',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-1',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true,
                    dex: 'osmosis'
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'secretnetwork',
            client_id: '07-tendermint-3',
            connection_id: 'connection-2'
        },
        chain_2: {
            chain_name: 'terra',
            client_id: '07-tendermint-28',
            connection_id: 'connection-29'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-2',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-16',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true,
                    properties: 'privacy'
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'terra',
            client_id: '07-tendermint-235',
            connection_id: 'connection-142'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-394',
            connection_id: 'connection-384'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-85',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-314',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    }
];
export default info;
